/**
 * Segments are grouped by type & granularity, in business order.
 * Everything else is derived from this structure:
 *  - {@link SEGMENT_KEY} — flat named access (e.g. `SEGMENT_KEY.BUDGET`)
 *  - the `*_SEGMENT_ORDER` arrays — per-(type, granularity) ordered lists used for sorting
 */
const SEGMENT_GROUPS = {
    consostyle: {
        macro: {
            BUDGET: 'budget',
            BONS_PLANS: 'bons_plans',
            PRATIQUE: 'pratique',
            NUTRITION: 'nutrition',
            GOURMET: 'gourmet'
        },
        micro: {
            BUDGET_SERRE: 'budget_serre',
            BUDGET_ARBITRE: 'budget_arbitre',
            BONS_PLANS_ACCRO: 'bons_plans_accro',
            BONS_PLANS_TRIBU: 'bons_plans_tribu',
            PRATIQUE_CONVIVIAL: 'pratique_convivial',
            PRATIQUE_PRESSE: 'pratique_presse',
            NUTRITION_LIGHT: 'nutrition_light',
            NUTRITION_BIO: 'nutrition_bio',
            GOURMET_PANIER_FRAIS: 'gourmet_panier_frais',
            GOURMET_AUTHENTIQUE: 'gourmet_authentique'
        }
    },
    lifestage: {
        macro: {
            FAMILLES: 'familles',
            SANS_ENFANTS: 'sans_enfants'
        },
        micro: {
            FAMILLE_AVEC_ENFANT_0_2_ANS: 'famille_avec_un_enfant_entre_0_et_2_ans',
            FAMILLE_AVEC_ENFANT_3_5_ANS: 'famille_avec_un_enfant_entre_3_et_5_ans',
            FAMILLE_AVEC_ENFANT_6_10_ANS: 'famille_avec_un_enfant_entre_6_et_10_ans',
            FAMILLE_AVEC_ENFANT_11_14_ANS: 'famille_avec_un_enfant_entre_11_et_14_ans',
            FAMILLE_AVEC_ENFANT_15_25_ANS: 'famille_avec_un_enfant_entre_15_et_25_ans',
            SANS_ENFANTS_18_24_ANS: '18_24_ans_sans_enfants',
            SANS_ENFANTS_25_39_ANS: '25_39_ans_sans_enfants',
            SANS_ENFANTS_40_64_ANS: '40_64_ans_sans_enfants',
            SANS_ENFANTS_OVER_65_ANS: '_de_65_ans_sans_enfants'
        }
    },
    special: {
        NO_SEGMENT: 'no_segment',
        OTHERS: 'others'
    }
};
export const SEGMENT_KEY = {
    ...SEGMENT_GROUPS.consostyle.macro,
    ...SEGMENT_GROUPS.consostyle.micro,
    ...SEGMENT_GROUPS.lifestage.macro,
    ...SEGMENT_GROUPS.lifestage.micro,
    ...SEGMENT_GROUPS.special
};
export const CONSOSTYLE_MACRO_SEGMENT_ORDER = Object.values(SEGMENT_GROUPS.consostyle.macro);
export const CONSOSTYLE_MICRO_SEGMENT_ORDER = Object.values(SEGMENT_GROUPS.consostyle.micro);
export const LIFESTAGE_MACRO_SEGMENT_ORDER = Object.values(SEGMENT_GROUPS.lifestage.macro);
export const LIFESTAGE_MICRO_SEGMENT_ORDER = Object.values(SEGMENT_GROUPS.lifestage.micro);
//# sourceMappingURL=segment-keys.js.map